import React from "react";
import { motion } from "framer-motion";

export default function Manifesto({ site }) {
    return (
        <section
            data-testid="manifesto-section"
            className="relative bg-ink-900 py-24 md:py-36"
        >
            <div className="mx-auto max-w-[1400px] px-5 md:px-10">
                <div className="grid grid-cols-12 gap-6 mb-14 md:mb-20 items-end">
                    <div className="col-span-12 lg:col-span-4">
                        <div className="font-mono-label text-lime-signal mb-4">03 — Manifesto</div>
                        <h2 className="font-display uppercase leading-[0.9] text-5xl md:text-6xl">
                            <span className="text-white">Why</span>
                            <br />
                            <span className="text-lime-signal">our neighbors</span>
                            <br />
                            <span className="text-chrome">choose us.</span>
                        </h2>
                    </div>
                    <div className="col-span-12 lg:col-span-6 lg:col-start-7">
                        <p className="text-white/60 leading-relaxed">
                            Five principles run every truck, every crew, every route across North Alabama. No shortcuts, no missed weeks, no excuses.
                        </p>
                    </div>
                </div>

                <div className="divide-y divide-white/10 border-y border-white/10">
                    {site.manifesto.map((m, i) => (
                        <motion.div
                            key={m.n}
                            initial={{ opacity: 0, y: 30 }}
                            whileInView={{ opacity: 1, y: 0 }}
                            viewport={{ once: true, margin: "-80px" }}
                            transition={{ duration: 0.7, delay: i * 0.08, ease: [0.19, 1, 0.22, 1] }}
                            className="grid grid-cols-12 items-center py-8 md:py-10 gap-4 md:gap-8 group hover:bg-white/[0.02] transition-colors"
                            data-testid={`manifesto-item-${i}`}
                        >
                            <div className="col-span-3 md:col-span-2 font-display text-6xl md:text-8xl leading-none text-stroke">
                                {m.n}
                            </div>
                            <div className="col-span-9 md:col-span-5">
                                <h3 className="font-display uppercase text-3xl md:text-5xl leading-none text-white group-hover:text-lime-signal transition-colors">
                                    {m.title}
                                </h3>
                            </div>
                            <div className="col-span-12 md:col-span-5">
                                <p className="text-white/60 md:text-base leading-relaxed">
                                    {m.desc}
                                </p>
                            </div>
                        </motion.div>
                    ))}
                </div>
            </div>
        </section>
    );
}
